import React, {Component} from 'react';
import {
	Button,
	Col,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Nav,
	NavItem,
	NavLink,
	Row,
	TabContent,
	TabPane
} from "reactstrap";
import Alert from 'react-s-alert';
import CustomerGeneralInfo from "./CustomerGeneralInfo";
import classnames from "classnames";
import CustomerCommercialInfo from "./CustomerCommercialInfo";
import CustomerBankInfo from "./CustomerBankInfo";
import CustomerBranchInfo from "./CustomerBranchInfo";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import CustomerContractInfo from "./CustomerContractInfo";
import CustomerUserInfo from "./CustomerUserInfo";
import MailProperty from "./MailProperty";
import NavBarKS from "../../../components/NavBarKS";
import _ from 'lodash';
import SweetAlert from 'react-bootstrap-sweetalert';
import CustomerWarningInfo from "./CustomerWarningInfo";
import SmmmUserModal from "../../smmmuserinformation/SmmmUserModal";
import {AuthPageType, CustomerBankType, EntegratorIdentifiers} from "../../../helper/enums";
import {EntegratorConf, VirtualHost} from "../../../constants";
import SmsProperty from "./SmsProperty";
import CustomerPriceListModal from "./CustomerPriceListModal";
import AuthPage from "../../AuthPage";
import {
	showBaro,
	showDbs,
	showTurmob,
	showUts,
	showEarsivInbox,
	showLuca,
	showChemistInformationModal
} from "../../../helper/permission";
import DefterBeyanBilgileri from "./DefterBeyanBilgileri";
import ConnectorConfigurationModal from "../../connector/ConnectorConfigurationModal";
import DefaultDbsHeaders from "./DefaultDbsHeaders";
import PredefinedSelectionModal from "./PredefinedSelectionModal";
import Select from 'react-select';
import LucaConfig from "./LucaConfig";
import UserCompanyDefinitionModal from "./UserCompanyDefinitionModal";
import DocumentNaming from "./DocumentNaming";

class CompanyProfile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: {},
			activeTab: '1',
			key: Math.random(),
			childValidInfo: false,
			currentTitle: null,
			addressTabModal: false,
			bankTabModal: false,
			isAlertVisible: false,
			branchConfirmModal: false,
			recentAliasList: [],
			isForbidden: false,
			mode: 'create',
			customerBank: {
				recordId: '',
				bankName: '',
				iban: '',
				type: showChemistInformationModal() ? CustomerBankType.SGK : CustomerBankType.OTHER
			},
			customerBranchAddress: {
				recordId: '',
				branchName: '',
				gbAlias: '',
				postboxAlias: '',
				country: 'Türkiye',
				city: '',
				citySubdivisionName: '',
				webSite: '',
				email: '',
				phone: '',
				fax: '',
				street: '',
				buildingName: '',
				buildingNo: '',
				doorNo: '',
				postalCode: ''
			},
			customerBankList: [],
			customerBranchList: [],
			customerContractList: [],
			distributorContractList: [],
			userList: [],
			naceCodeList: [],
			overlayDivStyle: {display: 'none'},
			spinnerStyle: {display: 'none'},
			customerPriceListModal: false,
			showConnectorConfigurationModal:false,
			isMobile:window.innerWidth > 991 ? false : true,
			options:
				[
					{value: 1, label: 'Sözleşme Bilgileri'},
					{value: 2, label: 'Şube Bilgileri'},

				],
			showUserDefaultDefinition: false,
			userDefinition: {}
		};

		this.onChangeCustomer = this.onChangeCustomer.bind(this);
		this.onCustomerTypeChange = this.onCustomerTypeChange.bind(this);
		this.onCustomerStatusChange = this.onCustomerStatusChange.bind(this);
		this.onChangeCustomerBranchAddress = this.onChangeCustomerBranchAddress.bind(this);
		this.onCityChange = this.onCityChange.bind(this);
		this.onAliasChange = this.onAliasChange.bind(this);
		this.onCitySubdivisionChange = this.onCitySubdivisionChange.bind(this);
		this.onChangeCustomerBank = this.onChangeCustomerBank.bind(this);
		this.getSubdivisionsByCityForCustomer = this.getSubdivisionsByCityForCustomer.bind(this);
		this.getSubdivisionsByCityForBranch = this.getSubdivisionsByCityForBranch.bind(this);
		this.toggle = this.toggle.bind(this);
		this.fetchValidDataFromChild = this.fetchValidDataFromChild.bind(this);
		this.addBankToCustomer = this.addBankToCustomer.bind(this);
		this.clearCustomerBranchAddress = this.clearCustomerBranchAddress.bind(this);
		this.clearCustomerBank = this.clearCustomerBank.bind(this);
		this.fillBankForm = this.fillBankForm.bind(this);
		this.setBankList = this.setBankList.bind(this);
		this.isChanged = this.isChanged.bind(this);
		this.deleteBankFromCustomer = this.deleteBankFromCustomer.bind(this);
		this.addBranchToCustomer = this.addBranchToCustomer.bind(this);
		this.checkBeforeSubmit = this.checkBeforeSubmit.bind(this);
		this.setContractToCustomer = this.setContractToCustomer.bind(this);
		this.addContractToCustomer = this.addContractToCustomer.bind(this);
		this.passRecentAliasList = this.passRecentAliasList.bind(this);
		this.updateCustomerUserList = this.updateCustomerUserList.bind(this);
		this.updateCustomer = this.updateCustomer.bind(this);
		this.removeAlias = this.removeAlias.bind(this);
		this.fillAddressForm = this.fillAddressForm.bind(this);
		this.onTaxOfficeChange = this.onTaxOfficeChange.bind(this);
		this.onChangeCustomerCity = this.onChangeCustomerCity.bind(this);
		this.onChangeNaceCodes = this.onChangeNaceCodes.bind(this);
		this.arrangeErrorMessage = this.arrangeErrorMessage.bind(this);
		this.defineReadableFieldName = this.defineReadableFieldName.bind(this);
		this.onChangeInvalidatedContractPrice = this.onChangeInvalidatedContractPrice.bind(this);
		this.onChangeInvalidatedContractExplanation = this.onChangeInvalidatedContractExplanation.bind(this);
		this.onCommercialSoftwareChange = this.onCommercialSoftwareChange.bind(this);
		this.addNewCustomerReference = this.addNewCustomerReference.bind(this);
		this.deleteCustomerReference = this.deleteCustomerReference.bind(this);
		this.clearCustomerReferences = this.clearCustomerReferences.bind(this);
		this.setReferencesToInitialState = this.setReferencesToInitialState.bind(this);
		this.manipulateContractList = this.manipulateContractList.bind(this);
		this.updateCustomerWarningList = this.updateCustomerWarningList.bind(this);
		this.setNewContractList = this.setNewContractList.bind(this);
		this.closeShowSmmInfoModal = this.closeShowSmmInfoModal.bind(this);
		this.closeUserDefaultDefinition = this.closeUserDefaultDefinition.bind(this);
	}

	componentDidMount() {
		let self = this;

		let params = {
			url: `/customer/cpEdit/${this.props.match.params.recordId}`,
			method: 'post'
		};
		request(params)
			.then(response => {
				if (response.data.customer.recordId === null) {
					this.setState({
						customer: response.data.customer,
						cities: response.data.cities,
						services: response.data.services,
						taxOffices: response.data.taxOffices,
						currencyCodes: response.data.currencyCodes,
						naceCodes: response.data.naceCodes,
						commercialSoftwares: response.data.commercialSoftwares,
						partners: response.data.partners,
						warningTypes: response.data.warningTypes,
						warningOptions: response.data.warningOptions,
						mode: 'create',
						informationMail: response.data.informationMail,
						bankList: response.data.bankList,
						accountantInformation: response.data.accountantInformation
					});
				} else {
					let customerBankList = null;
					let customerBranchList = null;
					let customerContractList = null;
					let userList = null;
					let naceCodeList = [];
					let distributorContractList = null;

					if (response.data.customer.customerBankList !== null) {
						customerBankList = response.data.customer.customerBankList;
					} else {
						customerBankList = []
					}

					if (response.data.customer.customerBranchList !== null) {
						let customerBranchs = response.data.customer.customerBranchList.map((item) => ({
							...item,
							uniqueId: Math.random().toString(36)
						}))
						customerBranchList = customerBranchs;
					} else {
						customerBranchList = []
					}

					if (response.data.customer.customerContractList !== null) {
						customerContractList = response.data.customer.customerContractList;
					} else {
						customerContractList = []
					}

					if (response.data.distributorContractList !== null) {
						distributorContractList = response.data.distributorContractList;
					} else {
						distributorContractList = []
					}

					if (response.data.customer.userList !== null) {
						userList = response.data.customer.userList;
					} else {
						userList = []
					}

					if (response.data.customer.naceCodeList !== null) {
						let respNcl = response.data.customer.naceCodeList;
						let customer = response.data.customer
						let ncl = [];

						respNcl.map(nc => {
							let naceCode = {};
							let tempNaceCode = {};
							tempNaceCode.id = nc.id;
							tempNaceCode.code = nc.code;
							tempNaceCode.description = nc.description;
							ncl.push(tempNaceCode);

							naceCode.value = nc.id;
							naceCode.label = nc.code + ' , ' + nc.description;
							naceCode.customValue = nc.code;

							naceCodeList.push(naceCode);
						});
						customer.naceCodeList = ncl;

					} else {
						naceCodeList = []
					}

					let initState = deepCopyObject(response.data.customer);

					this.setState({
						initState,
						customer: response.data.customer,
						cities: response.data.cities,
						services: response.data.services,
						taxOffices: response.data.taxOffices,
						naceCodes: response.data.naceCodes,
						commercialSoftwares: response.data.commercialSoftwares,
						partners: response.data.partners,
						warningTypes: response.data.warningTypes,
						warningOptions: response.data.warningOptions,
						customerBankList,
						customerBranchList,
						customerContractList,
						naceCodeList,
						userList,
						mode: 'edit',
						currencyCodes: response.data.currencyCodes,
						distributorContractList,
						informationMail: response.data.informationMail,
						bankList: response.data.bankList,
						accountantInformation: response.data.accountantInformation
					})
				}
				self.setMobileOptions();
			})
			.catch(function (error) {
				if (error.response) {
					if (error.response.status === 403) {
						self.setState({isForbidden: true})
					}
				}
			});
	}

	setContractToCustomer(data) {
		let clone = deepCopyObject(data);
		let ccsl = clone.customerContractServiceList;
		ccsl.map(ccs => {
			ccs.aliasList && ccs.aliasList.map(a => {
				delete a.service
			});
		});

		let customerContractList = this.state.customer.customerContractList;
		if (!customerContractList) {
			customerContractList = [];
		}

		if (customerContractList.length === 0) {
			customerContractList.push(clone)
		} else {
			customerContractList.splice(0, 1, clone)
		}

		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		})
	}

	passRecentAliasList(aliasList) {
		this.setState({
			recentAliasList: aliasList
		})
	}

	addContractToCustomer(data) {
		let clone = deepCopyObject(data);
		let ccsl = clone.customerContractServiceList;
		ccsl.map(ccs => {
			ccs.aliasList && ccs.aliasList.map(a => {
				delete a.service
			});
		});

		let customerContractList = this.state.customer.customerContractList
		customerContractList.push(clone);
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		})
	}

	onChangeCustomer(e) {
		if (e.target.name === "corporateMail" || e.target.name === "kepAdresi" || e.target.name === "sorumluEPosta") e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
		let customer = deepCopyObject(this.state.customer);
		let target = e.target;
		const value = target.type === 'checkbox' ? (target.checked) : target.value;

		customer[target.name] = value;
		if (target.name === "formattedName") {
			this.setState({
				customer,
				currentTitle: value
			})
		}
		if (target.name === "distributor" && value === false) {
			customer.allowPrivateAccess = false;
		}
		if (target.name === "informationMail") {
			customer.informationMail = value;
		}
		if (target.name === "cancelPermission" && value === true) {
			if (showBaro()) {
				this.setState({
					alert: (
						<SweetAlert warning
									confirmBtnText="Tamam"
									confirmBtnBsStyle="accept"
									title="e-Serbest Meslek Makbuzların 8 günden sonra iptal edilmesi yasal mevzuat
								hükümleri gereği önerilmemekte olup, tüm sorumluluk mükellefe aittir."
									onConfirm={() => this.setState({alert: null})}>
						</SweetAlert>
					)
				});
			} else {
				this.setState({
					alert: (
						<SweetAlert warning
									confirmBtnText="Tamam"
									confirmBtnBsStyle="accept"
									title="e-Arşiv Faturalarının 8 günden sonra iptal edilmesi yasal mevzuat hükümleri
								gereği önerilmemekte olup, tüm sorumluluk mükellefe aittir."
									onConfirm={() => this.setState({alert: null})}>
						</SweetAlert>
					)
				});
			}
		}

		this.setState({
			customer
		})
	}

	onCustomerTypeChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				customerType: e.value
			}
		})
	}

	onCustomerStatusChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				active: e.value
			}
		})
	}

	onTaxOfficeChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				taxOffice: e.value
			}
		})
	}

	onCommercialSoftwareChange(e) {
		this.setState({
			customer: {
				...this.state.customer,
				commercialSoftware: e.value
			}
		})
	}

	onChangeCustomerCity(data) {
		this.setState({
			customer: {
				...this.state.customer,
				city: data
			}
		})
	}

	// ADDRESS OPERATIONS - START
	onCityChange(e) {
		this.setState({
			customerBranchAddress: {
				...this.state.customerBranchAddress,
				city: e.value
			}
		})
	}

	onCitySubdivisionChange(e) {
		this.setState({
			customerBranchAddress: {
				...this.state.customerBranchAddress,
				citySubdivisionName: e.value
			}
		})
	}

	onAliasChange(e) {
		this.setState({
			customerBranchAddress: {
				...this.state.customerBranchAddress,
				[e.name]: e.value
			}
		})
	}

	fillAddressForm(data, index) {
		this.setState({
			newlyAddedBranchIndex: index,
			newlyAddedBranchEditing: true,
			customerBranchAddress: data
		})
	}

	getSubdivisionsByCityForCustomer(data) {
		if (data === null) {
			return [];
		}

		if (this.state.customerAddress.city !== '') {
			return this.state.cities.find(obj => obj.cityName === data).subdivisions.map(subdiv => ({
				value: subdiv.name,
				label: subdiv.name
			}))
		}
	}

	getSubdivisionsByCityForBranch(data) {
		if (data === null) {
			return [];
		}

		if (this.state.customerBranchAddress.city !== '') {
			let city = this.state.cities.find(obj => obj.cityName === data);
			if(city && city["subdivisions"]){
				return city["subdivisions"].map(subdiv => ({
					value: subdiv.name,
					label: subdiv.name
				}));
			}else{
				return [];
			}
		}
	}

	onChangeCustomerBranchAddress(e) {
		if(e.target.name === "email") e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
		let customerBranchAddress = deepCopyObject(this.state.customerBranchAddress);
		if (customerBranchAddress.uniqueId === undefined){
			customerBranchAddress["uniqueId"] = Math.random().toString(36);
		}
		if(e.target.name === 'hasMesulMudur'){
			if(e.target.checked){
				customerBranchAddress["mesulMudurAdSoyad"] = null;
				customerBranchAddress["mesulMudurBelgeNo"] = null;
				customerBranchAddress["mesulMudurRuhsatnameTarih"] = null;
			}
			customerBranchAddress[e.target.name] = !e.target.checked;
		}else{
			customerBranchAddress[e.target.name] = e.target.value === "" ? null : e.target.value;
		}
		this.setState({customerBranchAddress});
	}

	// ADDRESS OPERATIONS - END

	clearCustomerBranchAddress() {
		let customerBranchAddress = {
			recordId: '',
			branchName: '',
			gbAlias: '',
			postboxAlias: '',
			country: 'Türkiye',
			city: '',
			citySubdivisionName: '',
			webSite: '',
			email: '',
			phone: '',
			fax: '',
			street: '',
			buildingName: '',
			buildingNo: '',
			doorNo: '',
			postalCode: ''
		};
		this.setState({
			customerBranchAddress
		})
	}

	// BANK OPERATIONS - START
	onChangeCustomerBank(e, name) {
		if(e&&e.target){
			this.setState({
				customerBank: {
					...this.state.customerBank,
					[e.target.name]: e.target.name === "iban" ? e.target.value.replace(/\s/g, '') : e.target.value
				}
			})
		}else{
			this.setState({
				customerBank: {
					...this.state.customerBank,
					[name]:e.value
				}
			})
		}
	}

	clearCustomerBank() {
		let customerBank = {
			recordId: '',
			bankName: '',
			iban: '',
			type: showChemistInformationModal() ? CustomerBankType.SGK : CustomerBankType.OTHER
		};
		this.setState({
			customerBank
		})
	}

	addBankToCustomer() {
		let result = this.bankInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let customerBankList = deepCopyObject(this.state.customerBankList);
				customerBankList.push(this.state.customerBank);

				this.setState({
					customerBankList,
					customer: {
						...this.state.customer,
						customerBankList
					}
				}, () => this.clearCustomerBank());
			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}
		})
	}

	deleteBankFromCustomer(data) {
		let self = this;
		let params = {
			url: `/customer/deleteBank/${data}`,
			method: 'post'
		};
		self.setState({deleteBtnDisabled: true});
		request(params)
			.then(function (response) {
				Alert.success('Silme işlemi başarıyla gerçekleştirildi.', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	// BANK OPERATIONS - END

	fillBankForm(data) {
		this.setState({
			customerBank: data,
		})
	}
	setBankList(banklist){
		let customerBankList = deepCopyObject(banklist);

		this.setState({
			customerBankList,
			customer: {
				...this.state.customer,
				customerBankList
			}
		}, () => this.clearCustomerBank());
	}

	toggle(tab) {
		this.setState({
			activeTab: tab
		})
	}

	fetchValidDataFromChild(data) {
		this.setState({
			childValidInfo: data.valid
		})
	}

	checkBeforeSubmit() {
		let init = deepCopyObject(this.state.initState);
		let final = deepCopyObject(this.state.customer);
		if (!(_.isEqual(init, final))) {
			let error = {};

			let generalValidity = this.generalInfoChild.validateComponent();
			let generalInfoError = this.generalInfoChild.state.error;
			for (let key in generalInfoError) {
				error[key] = generalInfoError[key]
			}

			let commercialValidity = this.commercialInfoChild.validateComponent();
			let commercialInfoError = this.commercialInfoChild.state.error;
			for (let key in commercialInfoError) {
				error[key] = commercialInfoError[key]
			}

			let contractValidity = {};

			if (!this.state.customer.customerContractList) {
				contractValidity.valid = true;
			} else {
				contractValidity = this.contractInfoChild.validateComponent();
			}
			let contractInfoError = this.contractInfoChild.state.error;
			for (let key in contractInfoError) {
				error[key] = contractInfoError[key]
			}

			this.setState({
				error
			}, function () {
				if (generalValidity.valid && commercialValidity.valid && contractValidity.valid) {
					if (this.state.customer.customerBranchList === null) {
						this.setState({
							branchConfirmModal: true
						})
					} else {
						this.handleSubmit();
					}
				} else {
					Alert.error(this.arrangeErrorMessage(), {
						html: true,
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					})
				}
			});
		} else {
			Alert.warning('Herhangi bir değişiklik yapmadınız !', {
				html: true,
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			})
		}
	}

	arrangeErrorMessage() {
		let errorObject = deepCopyObject(this.state.error);
		let errorArray = [];

		for (let key in errorObject) {
			if (errorObject.hasOwnProperty(key)) {
				let error = {};
				if (!!errorObject[key].message && key !== 'tCity') {
					error.field = this.defineReadableFieldName(key);
					error.message = errorObject[key].message;
					errorArray.push(error);
				}
			}
		}
		this.setState({error: errorObject})

		let errorString = errorArray.map(error => '<strong>' + error.field + error.message + '</strong></br>').join("");

		return errorString;
	}

	defineReadableFieldName(key) {

		switch (key) {
			case 'tVknTckn':
				return 'Vkn/Tckn: ';
			case 'tCustomerName':
				return 'Müşteri Adı: ';
			case 'tFormattedName':
				return 'Unvan: ';
			case 'tCustomerType':
				return 'Müşteri Tipi: ';
			case 'tGivenName':
				return 'Adı: ';
			case 'tFamilyName':
				return 'Soyadı: ';
			case 'tCorporateMail':
				return 'Kurumsal e-Posta: ';
			case 'tTaxOffice':
				return 'Vergi Dairesi: ';
			case 'tContractStartDate':
				return 'Kontrat Başlangıç Tarihi: ';
			case 'tContractFinishDate':
				return 'Kontrat Bitiş Tarihi: ';
			case 'tRepresentative':
				return 'Müşteri Temsilcisi: ';
			case 'tRegistrantName':
				return 'Kaydeden Adı: ';
			case 'tRegistrantSurname':
				return 'Kaydeden Soyadı: ';
			case 'tRegistrantMobile':
				return 'Kaydeden Cep No: ';
			case 'tSorumluTckn':
				return 'Sorumlu Tckn: ';
			case 'tSorumluAd':
				return 'Sorumlu Adı: ';
			case 'tSorumluSoyad':
				return 'Sorumlu Soyadı: ';
			case 'tSorumluCepTel':
				return 'Sorumlu Cep No: ';
			case 'tSorumluEPosta':
				return 'Sorumlu e-Posta: ';
			default :
				return '';
		}
	}

	switchBranchDetailModal() {
		this.branchInfoChild.remoteSwitchBranchDetailModal();
	}

	handleSubmit() {
		this.overlayPage();
		let self = this;
		const data = this.state.customer;
		let params = {
			url: `/customer/createCustomer`,
			data: data,
			method: 'post'
		};
		request(params)
		// .then(() => {
		// Alert.success('Müşteri başarıyla kaydedildi', {
		// 	html: true,
		// 	position: 'top-right',
		// 	effect: 'stackslide',
		// 	timeout: 5000
		// });
		// self.props.history.push(`/companyProfile/${this.props.currentUser.customerId}`);
		// })
			.then(() => self.setState({overlayDivStyle: {display: 'none'}, spinnerStyle: {display: 'none'}}))
			.then(() => this.props.loadCurrentUser())
			.catch(function (error) {
				self.setState({overlayDivStyle: {display: 'none'}, spinnerStyle: {display: 'none'}});
				showAxiosError(error);
			});
	}

	isChanged(initState, input) {
		if (this.state.mode === 'create') {
			return false
		} else {
			if (initState === JSON.stringify(input)) {
				return true
			} else {
				return false
			}
		}
	}

	defineTabName() {
		if (this.state.activeTab === '1') {
			return 'Sözleşme Bilgileri'
		} else if (this.state.activeTab === '2') {
			return 'Şube Bilgileri'
		} else if (this.state.activeTab === '3') {
			return 'Banka Bilgileri'
		} else if (this.state.activeTab === '4') {
			return 'Kayıtlı Kullanıcılar'
		} else if (this.state.activeTab === '5'){
			return 'E-Posta Sunucu Bilgileri'
		} else if (this.state.activeTab === '6'){
			return 'Bildirim Bilgileri'
		} else {
			return ''
		}
	}

	addBranchToCustomer() {
		let result = this.branchInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let customerBranchAddress = deepCopyObject(this.state.customerBranchAddress);
				let customerBranchList = deepCopyObject(this.state.customerBranchList);

				if (customerBranchAddress.recordId) {
					let found = false;
					let index = null;

					customerBranchList.map(branch => {
						if (branch.recordId === customerBranchAddress.recordId) {
							found = true;
							index = customerBranchList.indexOf(branch);
						}
					});

					if (found === true) {
						customerBranchList.splice(index, 1, customerBranchAddress)
					}

				} else {
					if (this.state.newlyAddedBranchEditing) {
						let index = this.state.newlyAddedBranchIndex;
						if (customerBranchAddress.recordId) {
							customerBranchList.splice(index, 1, customerBranchAddress);
						} else {
							let updateIndex = customerBranchList.findIndex((t) => t.recordId === '' && t.uniqueId === customerBranchAddress.uniqueId);

							if (updateIndex !== -1){
								customerBranchList.splice(updateIndex, 1, customerBranchAddress);
							} else {
							customerBranchList.push(customerBranchAddress);
							}
						}

						this.setState({newlyAddedBranchEditing: false})
					} else {
						customerBranchList.push(customerBranchAddress);
					}
				}


				this.setState({

					customerBranchList,
					customer: {
						...this.state.customer,
						customerBranchList
					}
				}, () => this.clearCustomerBranchAddress());
				this.branchInfoChild.remoteSwitchBranchDetailModal();
			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		})
	}

	// saveEditedExternalCustomer() {
	//     const data = this.state.externalCustomer;
	//     if (data.externalCustomerBankList !== [] || data.externalCustomerBankList !== null) {
	//         this.handleSubmitWithBank()
	//     } else {
	//         axios.put(`/externalCustomer/createWithoutBank`, data)
	//             .then(() => {
	//                 browserHistory.push(`/externalCustomer`)
	//             })
	//             .catch(function (error) {
	//                 showAxiosError(error);
	//             });
	//     }
	// }

	removeAlias(data) {
		let aliasList = [];
		let customerContractList = deepCopyObject(this.state.customer.customerContractList)
		customerContractList.map(cc => {
			cc.customerContractServiceList.map(ccs => {
				if (ccs.service.recordId === 2) {
					aliasList = ccs.aliasList;
					if (data) {
						data.map(a => {
							aliasList.map(alias => {
								if (a.workScopecode === alias.workScopecode) {
									let index = aliasList.indexOf(alias);
									aliasList.splice(index, 1);
								}
							})
						})
					}
					ccs.aliasList = aliasList;
				}
			})
		});
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		})
	}

	updateCustomerUserList(userList) {
		this.setState({
			userList,
			customer: {
				...this.state.customer,
				userList
			}
		})
	}

	updateCustomer(data) {
		this.setState({
			customer: data
		})
	}

	onChangeNaceCodes(data) {
		let customer = deepCopyObject(this.state.customer);
		let customerNcList = [];
		data.map(d => customerNcList.push({id: d.value}));
		customer.naceCodeList = customerNcList;
		this.setState({customer, naceCodeList: data})
	}

	onChangeInvalidatedContractPrice(e, data) {
		let customer = deepCopyObject(this.state.customer);
		let customerContractList = customer.customerContractList;

		let ccIndex = null;
		let ccsIndex = null;
		customerContractList.map(cc => {
			cc.customerContractServiceList.map(ccs => {
				if (data.id === ccs.id) {
					ccIndex = customerContractList.indexOf(cc);
					ccsIndex = cc.customerContractServiceList.indexOf(ccs);
				}
			})
		});

		customerContractList[ccIndex].customerContractServiceList[ccsIndex].price = e.target.value;

		this.setState({customer});
	}

	onChangeInvalidatedContractExplanation(e, data) {
		let customer = deepCopyObject(this.state.customer);
		let customerContractList = customer.customerContractList;

		let ccIndex = null;
		let ccsIndex = null;
		customerContractList.map(cc => {
			cc.customerContractServiceList.map(ccs => {
				if (data.id === ccs.id) {
					ccIndex = customerContractList.indexOf(cc);
					ccsIndex = cc.customerContractServiceList.indexOf(ccs);
				}
			})
		});

		customerContractList[ccIndex].customerContractServiceList[ccsIndex].explanation = e.target.value;

		this.setState({customer});
	}

	overlayPage() {
		let overlayDivStyle = {};
		let spinnerStyle = {};

		let offsetWidth = document.getElementById('contentDiv').offsetWidth;
		let offsetHeight = document.getElementById('contentDiv').offsetHeight;
		overlayDivStyle.position = 'absolute';
		overlayDivStyle.zIndex = '1';
		overlayDivStyle.background = 'white';
		overlayDivStyle.opacity = '0.5';
		overlayDivStyle.width = offsetWidth;
		overlayDivStyle.height = offsetHeight;

		spinnerStyle.position = 'fixed';
		spinnerStyle.zIndex = '2';
		spinnerStyle.left = '56%';
		spinnerStyle.top = '50%';
		spinnerStyle.fontSize = '50px';

		this.setState({overlayDivStyle, spinnerStyle})
	}

	addNewCustomerReference(partner) {
		let customer = deepCopyObject(this.state.customer);
		let customerReferences = customer.customerReferences;
		let newReference = {partner: partner};
		customerReferences.push(newReference);

		this.setState({customer})
	}

	deleteCustomerReference(reference) {
		let customer = deepCopyObject(this.state.customer);
		let customerReferences = customer.customerReferences;

		const deleteAll = () => {
			customerReferences.splice(0, customerReferences.length);
			this.setState({
				customer,
				alert: null
			})
		};

		const deleteSelected = () => {
			let index = null;
			customerReferences.map(cr => {
				if (cr.partner.recordId === reference.partner.recordId) {
					index = customerReferences.indexOf(cr);
				}
			});

			customerReferences.splice(index, 1);

			this.setState({
				customer,
				alert: null
			})
		};

		if (reference.partner.referencePartner === null) {
			this.setState({
				alert: (
					<SweetAlert showCancel warning
								confirmBtnText="Evet"
								cancelBtnText="Hayır"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="Emin misiniz?"
								onConfirm={() => deleteAll()}
								onCancel={() => this.setState({alert: null})}
					>
						{"Referans bilgileri sıfırlanacak."}
					</SweetAlert>
				)
			});
		} else {
			this.setState({
				alert: (
					<SweetAlert showCancel warning
								confirmBtnText="Evet"
								cancelBtnText="Hayır"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="Emin misiniz?"
								onConfirm={() => deleteSelected()}
								onCancel={() => this.setState({alert: null})}
					>
						{"Emin misiniz ?"}
					</SweetAlert>
				)
			});
		}
	}

	clearCustomerReferences() {
		let customer = deepCopyObject(this.state.customer);
		let customerReferences = customer.customerReferences;

		customerReferences.splice(0, customerReferences.length);

		this.setState({customer})
	}

	setReferencesToInitialState(initialReferenceList) {
		let customer = deepCopyObject(this.state.customer);
		customer.customerReferences = initialReferenceList;

		this.setState({customer})
	}

	manipulateContractList(id) {
		let customerContractList = deepCopyObject(this.state.customerContractList);
		customerContractList && customerContractList.map(c => {
			c.customerContractServiceList && c.customerContractServiceList.map(cs => {
				if (cs.recordId === id) {
					cs.terminated = true;
				}
			})
		});
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList
			}
		})
	}

	setNewContractList(newList) {
		this.setState({
			customer: {
				...this.state.customer,
				customerContractList: newList
			}
		})
	}

	updateCustomerWarningList(currentWarnings) {
		this.setState({
			customer: {
				...this.state.customer,
				customerWarnings: currentWarnings
			}
		})
	}

	closeShowSmmInfoModal() {
		this.setState({
			showSmmInfoModal: false
		})
	}
	closeConnectorConfigurationModal = () => {
		this.setState({
			showConnectorConfigurationModal: false
		})
	}

	mobileSelectToggler = (tab,label) => {

		this.toggle(tab);

		if(tab === '18' && label ==='Konnektör Bilgileri') {
			this.setState({showConnectorConfigurationModal: true});
		}
		if(tab === '9') {
			this.setState({customerPriceListModal: true});
		}

		if(tab === '7') {
			this.setState({showSmmInfoModal: true});
		}

		if(tab === '20'){
			this.setState({showUserDefaultDefinition: true});
		}
	}

	closeUserDefaultDefinition(userDefinition){
		this.setState({showUserDefaultDefinition: false, userDefinition});
	}

	setMobileOptions = () => {
		let { options } = this.state;
		let currentUser = deepCopyObject(this.props.currentUser);


			if(false) {
				options.push({value:6, label:"Uyarı Bilgileri"})
			}

			if([EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
				options.push({value:7, label:'Muhasebeci Bilgileri'})
			}

			if([EntegratorIdentifiers.KOLAYSOFT,
					EntegratorIdentifiers.SMART,
					EntegratorIdentifiers.MBT,
					EntegratorIdentifiers.BYM,
					EntegratorIdentifiers.AKTIF].includes(EntegratorConf.identifier) && this.props.isEntegrator && this.props.isAdminUser
				&& !["111111444", "111111888", "111111999"].includes(this.props.currentUser.username)) {
				options.push({value:9, label:'Paytr Fiyat Listesi'})
			}

			if(showUts(this.props.currentUser.parentCustomerId)) {
				options.push({value:10, label:'ÜTS Token Bilgisi'})
			}

			if([EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
				options.push({value:11, label:'TÜRMOB Token Bilgisi'})
			}

			if(showDbs()) {
				options.push({value:12, label:'DBS Giriş Bilgileri'})
				options.push({value:16, label:'DBS Varsayılan Belge Seçimleri'})
			}

			if(this.state.customer.accountant && showDbs()) {
				options.push({value:13, label:'Defter Beyan Bilgileri'})
			}

			if(this.props.isEbelge ||
				(this.props.isEArsiv && showEarsivInbox(EntegratorConf.identifier))) {
				options.push({value:14, label:'İnteraktif Vergi Dairesi Giriş Bilgileri'})
			}

			if(this.props.isEKonnektor) {
				options.push({value:18, label:'Konnektör Bilgileri'})
			}

		// if ([EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
		// 		options.push({value:15, label:'Çicek Sepeti Giriş Bilgileri'})
		// 	}

			if ([EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
				options.push({value:27, label:'Trendyol Entegrasyon Bilgileri'})
			}
			// if ([EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
			// 	options.push({value:22, label:'Hepsiburada Entegrasyon Bilgileri'})
			// }
			// if ([EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
			// 	options.push({value:23, label:'N11 Entegrasyon Bilgileri'})
			// }
			// if ([EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
			// 	options.push({value:24, label:'Pazarama Entegrasyon Bilgileri'})
			// }
			// if ([EntegratorIdentifiers.MBT, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier)) {
			// 	options.push({value:25, label:'İkas Entegrasyon Bilgileri'})
			// }

		if ((this.state.mode === 'edit' && currentUser.customerId === this.state.customer.recordId)) {

			if (!!this.state.customer.earchiveSmsSend && (EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier)) {
				options.push({value: 8, label: 'SMS Bilgisi'})
			}

			options.push({value: 3, label: 'Banka Bilgileri'});
			options.push({value: 4, label: 'Kullanıcı Bilgileri'});
			options.push({value: 5, label: 'E-Posta Sunucu Bilgisi'});
			options.push({value: 17, label: 'Öntanımlı Fatura Ayarları'});


		}

		this.setState({options})
	}

	render() {

		let {isMobile,options} = this.state;
		let currentUser = deepCopyObject(this.props.currentUser);

		if (this.state.customer === undefined)
			if (!this.state.isForbidden) {
				return (<div className="row">Yükleniyor...</div>);
			} else {
				return (<div className="row"><h5>Bu sayfaya erişemezsiniz !</h5></div>);
			}

		return (
			<div className="row baseBackground">

				<div>{this.state.alert}</div>

				<div id='overlayDiv' style={this.state.overlayDivStyle}/>
				<i className="fas fa-spinner fa-spin" style={this.state.spinnerStyle}/>


				<div id='contentDiv'>
					<NavBarKS/>
					<div className="satirBasi">
						<div className="">
							<div className="card-header card-header-danger">
								<h4 className="card-title" style={{marginBottom: '20px'}}>Müşteri Genel Bilgileri</h4>
							</div>
							<div className=" col-sm-12 row">
								<div className="col-sm-12 FormRenk  " style={{marginLeft: '15px', paddingTop: '30px'}}>
									<CustomerGeneralInfo ref={instance => {
										this.generalInfoChild = instance
									}}
														 customer={this.state.customer}
														 onChangeCustomer={this.onChangeCustomer}
														 onCustomerTypeChange={this.onCustomerTypeChange}
														 onCustomerStatusChange={this.onCustomerStatusChange}
														 mode={this.state.mode}
														 currentUser={this.props.currentUser}
														 naceCodes={this.state.naceCodes}
														 onChangeNaceCodes={this.onChangeNaceCodes}
														 naceCodeList={this.state.naceCodeList}
														 name={this.props.name}
														 accountantInformation={this.state.accountantInformation}
														 switch/>


									<div className="">
										<CustomerCommercialInfo ref={instance => {
											this.commercialInfoChild = instance
										}}
																customer={this.state.customer}
																onChangeCustomer={this.onChangeCustomer}
																onTaxOfficeChange={this.onTaxOfficeChange}
																mode={this.state.mode}
																taxOffices={this.state.taxOffices}
																cities={this.state.cities}
																onChangeCustomerCity={this.onChangeCustomerCity}
																commercialSoftwares={this.state.commercialSoftwares}
																onCommercialSoftwareChange={this.onCommercialSoftwareChange}
																partners={this.state.partners}
																addNewCustomerReference={this.addNewCustomerReference}
																deleteCustomerReference={this.deleteCustomerReference}
																clearCustomerReferences={this.clearCustomerReferences}
																setReferencesToInitialState={this.setReferencesToInitialState}
																switch/>
									</div>

								</div>
							</div>
							{/*<div className="col-sm-2"></div>*/}
							{/*<hr/>*/}

							{/*<Row>*/}
							{/*<Col sm="12">*/}
							{/*<CustomerAdminUserInfo ref={instance => {*/}
							{/*this.adminUserInfoChild = instance*/}
							{/*}}*/}
							{/*userList={this.state.userList}*/}
							{/*updateCustomerUserList={this.updateCustomerUserList}/>*/}
							{/*</Col>*/}
							{/*</Row>*/}
						</div>


						<div className="card-nav-tabs">
							<div className="">

								<div className="card-header card-header-danger">
									<h4 className="card-title">{this.defineTabName()}</h4>
								</div>

								<div className="col-sm-12">
									{!isMobile && <Nav pills className="nav-pills-primary ">
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '1'})}
												onClick={() => {
													this.toggle('1');
												}}
											>
												Sözleşme Bilgileri
											</NavLink>
										</NavItem>

										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '2'})}
												onClick={() => {
													this.toggle('2');
												}}
											>
												Şube Bilgileri
											</NavLink>
										</NavItem>

										{(this.state.mode === 'edit' && currentUser.customerId === this.state.customer.recordId) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '3'})}
													onClick={() => {
														this.toggle('3');
													}}
												>
													Banka Bilgileri
												</NavLink>
											</NavItem>}

										{(this.state.mode === 'edit' && currentUser.customerId === this.state.customer.recordId) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '4'})}
													onClick={() => {
														this.toggle('4');
													}}
												>
													Kullanıcı Bilgileri
												</NavLink>
											</NavItem>}

										{(this.state.mode === 'edit' && currentUser.customerId === this.state.customer.recordId) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '5'})}
													onClick={() => {
														this.toggle('5');
													}}
												>
													E-Posta Sunucu Bilgisi
												</NavLink>
											</NavItem>}

										{(this.state.mode === 'edit' && currentUser.customerId === this.state.customer.recordId
												&& !!this.state.customer.earchiveSmsSend &&
												(EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier)) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '8'})}
													onClick={() => {
														this.toggle('8');
													}}
												>
													SMS Bilgisi
												</NavLink>
											</NavItem>}

										{false &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '6'})}
													onClick={() => {
														this.toggle('6');
													}}
												>
													Uyarı Bilgileri
												</NavLink>
											</NavItem>}

										{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '7'})}
													onClick={() => {
														this.toggle('7');
														this.setState({showSmmInfoModal: true});
													}}
												>
													Muhasebeci Bilgileri
												</NavLink>
											</NavItem>}
										{[EntegratorIdentifiers.KOLAYSOFT,
												EntegratorIdentifiers.SMART,
												EntegratorIdentifiers.MBT,
												EntegratorIdentifiers.BYM,
												EntegratorIdentifiers.AKTIF].includes(EntegratorConf.identifier) && this.props.isEntegrator && this.props.isAdminUser
											&& !["111111444", "111111888", "111111999"].includes(this.props.currentUser.username) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '9'})}
													onClick={() => {
														this.toggle('9');
														this.setState({customerPriceListModal: true});
													}}
												>
													Paytr Fiyat Listesi
												</NavLink>
											</NavItem>}

										{showUts(this.props.currentUser.parentCustomerId) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '10'})}
													onClick={() => {
														this.toggle('10');
													}}
												>
													ÜTS Token Bilgisi
												</NavLink>
											</NavItem>}

										{showTurmob(EntegratorConf.identifier) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '11'})}
													onClick={() => {
														this.toggle('11');
													}}
												>
													TüRMOB Token Bilgisi
												</NavLink>
											</NavItem>}

										{showDbs() &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '12'})}
													onClick={() => {
														this.toggle('12');
													}}
												>
													DBS Giriş Bilgileri
												</NavLink>
											</NavItem>}
										{this.state.customer.accountant && showDbs() &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '13'})}
													onClick={() => {
														this.toggle('13');
													}}
												>
													Defter Beyan Bilgileri
												</NavLink>
											</NavItem>}

										{(this.props.isEbelge || (this.props.isEArsiv && showEarsivInbox(EntegratorConf.identifier))) &&
										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '14'})}
												onClick={() => {
													this.toggle('14');
												}}
											>
												İnteraktif Vergi Dairesi Giriş Bilgileri
											</NavLink>
										</NavItem>}

										{this.props.isEKonnektor && EntegratorConf.identifier !== EntegratorIdentifiers.ZIRVE && <NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '18'})}
												onClick={() => {
													this.toggle('18');
													this.setState({showConnectorConfigurationModal: true});
												}}
											>
												Konnektör Bilgileri
											</NavLink>
										</NavItem>}

										{showDbs() &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '16'})}
													onClick={() => {
														this.toggle('16');
													}}
												>
													DBS Varsayılan Belge Seçimleri
												</NavLink>
											</NavItem>}

										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '17'})}
												onClick={() => {
													this.toggle('17');
												}}
											>
												Öntanımlı Fatura Ayarları
											</NavLink>
										</NavItem>

										{this.props.isEFatura &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '20'})}
													onClick={() => {
														this.toggle('20');
														this.setState({showUserDefaultDefinition: true});
													}}
												>
													Firma Kullanıcı Bazlı Tanım
												</NavLink>
											</NavItem>
										}

										{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '27'})}
													onClick={() => {
														this.toggle('27');
													}}
												>
													Trendyol Entegrasyon Bilgileri
												</NavLink>
											</NavItem>}

										<NavItem>
											<NavLink
												className={classnames({active: this.state.activeTab === '28'})}
												onClick={() => {
													this.toggle('28');
												}}
											>
												Toplu Pdf İndir Seçenekler
											</NavLink>
										</NavItem>

										{/*{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&*/}
										{/*	<NavItem>*/}
										{/*		<NavLink*/}
										{/*			className={classnames({active: this.state.activeTab === '22'})}*/}
										{/*			onClick={() => {*/}
										{/*				this.toggle('22');*/}
										{/*			}}*/}
										{/*		>*/}
										{/*			Hepsiburada Entegrasyon Bilgileri*/}
										{/*		</NavLink>*/}
										{/*	</NavItem>}*/}
										{/*{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&*/}
										{/*	<NavItem>*/}
										{/*		<NavLink*/}
										{/*			className={classnames({active: this.state.activeTab === '15'})}*/}
										{/*			onClick={() => {*/}
										{/*				this.toggle('15');*/}
										{/*			}}*/}
										{/*		>*/}
										{/*			Çiceksepeti Entegrasyon Bilgileri*/}
										{/*		</NavLink>*/}
										{/*	</NavItem>}*/}
										{/*{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&*/}
										{/*	<NavItem>*/}
										{/*		<NavLink*/}
										{/*			className={classnames({active: this.state.activeTab === '23'})}*/}
										{/*			onClick={() => {*/}
										{/*				this.toggle('23');*/}
										{/*			}}*/}
										{/*		>*/}
										{/*			N11 Entegrasyon Bilgileri*/}
										{/*		</NavLink>*/}
										{/*	</NavItem>}*/}
										{/*{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&*/}
										{/*	<NavItem>*/}
										{/*		<NavLink*/}
										{/*			className={classnames({active: this.state.activeTab === '24'})}*/}
										{/*			onClick={() => {*/}
										{/*				this.toggle('24');*/}
										{/*			}}*/}
										{/*		>*/}
										{/*			Pazarama Entegrasyon Bilgileri*/}
										{/*		</NavLink>*/}
										{/*	</NavItem>}*/}
										{/*{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&*/}
										{/*	<NavItem>*/}
										{/*		<NavLink*/}
										{/*			className={classnames({active: this.state.activeTab === '25'})}*/}
										{/*			onClick={() => {*/}
										{/*				this.toggle('25');*/}
										{/*			}}*/}
										{/*		>*/}
										{/*			İkas Entegrasyon Bilgileri*/}
										{/*		</NavLink>*/}
										{/*	</NavItem>}*/}

										{/*{showLuca(EntegratorConf.identifier) &&
											<NavItem>
												<NavLink
													className={classnames({active: this.state.activeTab === '19'})}
													onClick={() => {
														this.toggle('19');
													}}
												>
													Luca Bilgileri
												</NavLink>
											</NavItem>
										}*/}
									</Nav>
									}

									{isMobile &&
										<Select
											options={options}
											placeholder="Seçiniz..."
											onChange={(e)=>{this.mobileSelectToggler(e.value.toString(),e.label)}}
											isSearchable={false}
										/>
									}
								</div>

								<hr style={{marginBottom: '20px'}}></hr>


								<div className="card-body">
									<TabContent activeTab={this.state.activeTab}>
										<TabPane tabId="1">
											<div className="">
												<div className="">
													<CustomerContractInfo ref={instance => {
														this.contractInfoChild = instance
													}}
																		  onChangeInvalidatedContractPrice={this.onChangeInvalidatedContractPrice}
																		  onChangeInvalidatedContractExplanation={this.onChangeInvalidatedContractExplanation}
																		  customer={this.state.customer}
																		  services={this.state.services}
																		  updateCustomer={this.updateCustomer}
																		  setContractToCustomer={this.setContractToCustomer}
																		  customerContractList={this.state.customerContractList}
																		  addContractToCustomer={this.addContractToCustomer}
																		  passRecentAliasList={this.passRecentAliasList}
																		  currencyCodes={this.state.currencyCodes}
																		  history={this.props.history}
																		  removeAlias={this.removeAlias}
																		  isEntegrator={this.props.isEntegrator}
																		  isAdminUser={this.props.isAdminUser}
																		  isDistributor={this.props.isDistributor}
																		  manipulateContractList={this.manipulateContractList}
																		  currentUser={this.props.currentUser}
																		  expiringContracts={this.props.expiringContracts}
																		  redefineExpiringContracts={this.props.redefineExpiringContracts}
																		  setNewContractList={this.setNewContractList}
																		  distributorContractList={this.state.distributorContractList}
																		  switch/>
												</div>
											</ div>
										</TabPane>

										<TabPane tabId="2">
											<Row>
												<Col sm="12">
													<CustomerBranchInfo ref={instance => {
														this.branchInfoChild = instance
													}}
																		branchList={this.state.customerBranchList}
																		fillAddressForm={this.fillAddressForm}
																		customerBranchAddress={this.state.customerBranchAddress}
																		cities={this.state.cities}
																		getSubdivisions={this.getSubdivisionsByCityForBranch}
																		onChangeCustomerBranchAddress={this.onChangeCustomerBranchAddress}
																		onCityChange={this.onCityChange}
																		onAliasChange={this.onAliasChange}
																		onCitySubdivisionChange={this.onCitySubdivisionChange}
																		addBranchToCustomer={this.addBranchToCustomer}
																		customerContractList={this.state.customerContractList}
																		aliasList={this.state.recentAliasList}
																		clearCustomerBranchAddress={this.clearCustomerBranchAddress}
																		mode={this.state.mode}
																		reload={this.props.reload}/>
												</Col>
											</Row>
										</TabPane>

										<TabPane tabId="3">
											<Row>
												<Col sm="12">
													<CustomerBankInfo ref={instance => {
														this.bankInfoChild = instance
													}}
																	  customer={this.state.customer}
																	  currentTitle={this.state.currentTitle}
																	  onChangeCustomerBank={this.onChangeCustomerBank}
																	  customerBank={this.state.customerBank}
																	  addBankToCustomer={this.addBankToCustomer}
																	  customerBankList={this.state.customerBankList}
																	  fillBankForm={this.fillBankForm}
																	  clearForm={this.clearExternalCustomerBank}
																	  deleteBank={this.deleteBankFromExternalCustomer}
																	  clearCustomerBank={this.clearCustomerBank}
																	  setBankList={this.setBankList}
																	  bankList={this.state.bankList}
																	  reload={this.props.reload}/>
												</Col>
											</Row>
										</TabPane>

										{this.state.mode === 'edit' &&
										<TabPane tabId="4">
											<Row>
												<Col sm="12">
													<CustomerUserInfo userList={this.state.userList}/>
												</Col>
											</Row>
										</TabPane>}

										{this.state.mode === 'edit' &&
										<TabPane tabId="5">
											<MailProperty customer={this.state.customer}/>
										</TabPane>
										}

										{<TabPane tabId="8">
											{this.state.mode === 'edit' &&
											(EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier) &&
											<SmsProperty
											customer={this.state.customer}/>
											}
										</TabPane>
										}

										{this.state.mode === 'edit' &&
										<TabPane tabId="6">
											<div className="">
												<div className="">
													<CustomerWarningInfo customer={this.state.customer} warningTypes={this.state.warningTypes}
																							 warningOptions={this.state.warningOptions}
																							 updateCustomerWarningList={this.updateCustomerWarningList}/>
												</div>
											</ div>
										</TabPane>
										}
										{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(EntegratorConf.identifier) &&
										<TabPane tabId="7">
											<SmmmUserModal
												customer={this.state.customer}
												isOpen={this.state.showSmmInfoModal}
												toggle={this.closeShowSmmInfoModal}/>
										</TabPane>}
										<TabPane tabId="18">
											<ConnectorConfigurationModal
												customer={this.state.customer}
												isOpen={this.state.showConnectorConfigurationModal}
												toggle={this.closeConnectorConfigurationModal}/>
										</TabPane>

										<TabPane tabId="16">
											<DefaultDbsHeaders
												customer={this.state.customer}
												currentUser={this.props.currentUser}
											/>
										</TabPane>

										<TabPane tabId="17">
											<PredefinedSelectionModal
												customer={this.state.customer}
												currentUser={this.props.currentUser}
												isEbelge={this.props.isEbelge}
												isEArsiv={this.props.isEArsiv}
												isEFatura={this.props.isEFatura}
											/>
										</TabPane>

										{[EntegratorIdentifiers.KOLAYSOFT,
												EntegratorIdentifiers.SMART,
												EntegratorIdentifiers.MBT,
												EntegratorIdentifiers.BYM,
												EntegratorIdentifiers.AKTIF].includes(EntegratorConf.identifier) && this.props.isEntegrator && this.props.isAdminUser
										&& !["111111444","111111888", "111111999"].includes(this.props.currentUser.username) &&
										<TabPane tabId="9">
											<CustomerPriceListModal isOpen={this.state.customerPriceListModal}
																	toggle={() => this.setState({customerPriceListModal: false})}
																	customer={this.state.customer}
																	currentUser={this.props.currentUser}
											/>
										</TabPane>}


										{showUts(this.props.currentUser.parentCustomerId) &&
										<TabPane tabId="10">
											<AuthPage type={AuthPageType.UTS}/>
										</TabPane>}

										{showTurmob(EntegratorConf.identifier) &&
										<TabPane tabId="11">
											<AuthPage type={AuthPageType.TURMOB}/>
										</TabPane>}

										{showDbs() &&
										<TabPane tabId="12">
											<AuthPage type={AuthPageType.DBS}/>
										</TabPane>}

										{this.state.customer.accountant && showDbs() &&
										<TabPane tabId="13">
											<DefterBeyanBilgileri
												customer={this.state.customer}
											/>
										</TabPane>
										}

										{(this.props.isEbelge || (this.props.isEArsiv && showEarsivInbox(EntegratorConf.identifier))) &&
										<TabPane tabId="14">
											<AuthPage type={AuthPageType.INTERAKTIFVD}/>
										</TabPane>}

										{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&
                                        <TabPane tabId="15">
                                            <AuthPage type={AuthPageType.CICEKSEPETI}/>
                                        </TabPane>}

										{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&
											<TabPane tabId="27">
												<AuthPage type={AuthPageType.TRENDYOL}/>
											</TabPane>
										}
										{/*{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&*/}
										{/*	<TabPane tabId="21">*/}
										{/*		<AuthPage type={AuthPageType.HEPSIBURADA}/>*/}
										{/*	</TabPane>*/}
										{/*}*/}
										{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&
											<TabPane tabId="22">
												<AuthPage type={AuthPageType.N11}/>
											</TabPane>
										}
										{/*{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&*/}
										{/*	<TabPane tabId="23">*/}
										{/*		<AuthPage type={AuthPageType.PAZARAMA}/>*/}
										{/*	</TabPane>*/}
										{/*}*/}
										{[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&
											<TabPane tabId="24">
												<AuthPage type={AuthPageType.IKAS}/>
											</TabPane>
										}

										{showLuca(EntegratorConf.identifier) &&
											<TabPane tabId="19">
												<LucaConfig customer={this.state.customer}
															currentUser={this.props.currentUser}/>
											</TabPane>
										}
										{this.props.isEFatura &&
											<TabPane tabId="20">
												<UserCompanyDefinitionModal
													userDefinition={this.state.userDefinition}
													customer={this.state.customer}
													isOpen={this.state.showUserDefaultDefinition}
													toggle={this.closeUserDefaultDefinition}/>
											</TabPane>
										}
										<TabPane tabId="28">
											<DocumentNaming
												customer={this.state.customer}
												currentUser={this.props.currentUser}
											/>
										</TabPane>
									</TabContent>
								</div>
							</div>

							{this.state.mode === 'create' &&
							<div>
								<div className="col-sm-12">
									<nav className="col-sm-12">
										<button type="button" data-toggle="tooltip" data-placement="bottom"
												style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', float: 'right'}}
												rel="tooltip" className="TekBtn kaydet btn-icon"
												onClick={() => {
													this.checkBeforeSubmit()
												}}>Müşterİyİ Kaydet
										</button>
									</nav>
								</div>
							</div>}

							{this.state.mode === 'edit' &&
							<div className="col-sm-12">

								<div className="col-sm-12" style={{marginBottom: '20px'}}>
									<nav className="">
										<div key={this.state.key}>
											<button type="button" data-toggle="tooltip" data-placement="bottom"
													style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', float: 'right'}}
													rel="tooltip" className="TekBtn kaydet btn-icon"
													onClick={() => {
														this.checkBeforeSubmit()
													}}>Değişiklikleri Kaydet
											</button>
										</div>
									</nav>
								</div>
							</div>}
						</div>

						<Modal isOpen={this.state.branchConfirmModal}>
							<ModalHeader toggle={this.toggle}>Emin misiniz ?</ModalHeader>
							<ModalBody>
								En az bir şube kaydı olmadan müşteri kaydedilemez.
							</ModalBody>
							<ModalFooter>
								<div className="col-sm-4">
									<Button color="primary" className="TekBtn ekle"
											onClick={() => this.setState({branchConfirmModal: false}, this.switchBranchDetailModal())}>Şube
										Ekle</Button>
								</div>
								<div className="col-sm-4"></div>
								<div className="col-sm-4">
									<Button color="secondary" onClick={() => this.setState({
										branchConfirmModal: false
									})}>İptal</Button>
								</div>
							</ModalFooter>
						</Modal>
					</div>
				</div>
			</div>
		)
	}
}

export default CompanyProfile;

